<!-- 销售合同数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                    <el-form label-width="120px" :disabled="dataActionBox.actionType == 2" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                                            <el-form-item v-if="formOneValue.isShow == 1" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" :prop="formOneValue.entityField"
                                                          v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 是否有订单 -->
                                                <el-switch class="form_codition" v-if="formOneValue.entityField == 'isDetail'" title="switch" @change="changeOrder" :disabled="isChange" v-model="isShowDetail">
                                                </el-switch>
                                                <!-- 普通日期 -->
                                                <el-date-picker v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                                                                format="yyyy 年 MM 月 dd 日" value-format="timestamp" style="width:193px" type="date" :placeholder="'选择' + formOneValue.showField"
                                                                :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                </el-date-picker>
                                                <!-- 检索方案 -->
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" :disabled="formOneValue.isChange == 0">
                                                        <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                                                            :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                            effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                              @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                              :disabled="formOneValue.isChange == 0">
                                                        <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                                   :disabled="formOneValue.isChange == 0">
                                                        </el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- 返利金额 -->
                                                <el-input v-else-if="formOneValue.entityField == 'conmRemoney'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]" type="number"
                                                          min="0">
                                                </el-input>
                                                <!-- 返利比例 -->
                                                <el-input v-else-if="formOneValue.entityField == 'conmReproportion'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                                                          type="number" min="0">
                                                </el-input>
                                                <el-select v-else-if="formOneValue.entityField == 'conmType'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in dictionariesData.XSHTLX" :key="item.diValue" :label="item.diName" :value="item.diValue">
                                                    </el-option>
                                                </el-select>
                                                <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" :disabled="formOneValue.isChange == 0" @change="$forceUpdate()"
                                                           v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <el-input @input="$forceUpdate()" @keyup.enter.native="nextFocus(formOneKey)" v-else v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                          :maxlength="$store.state.inputLength">
                                                </el-input>
                                            </el-form-item>
                                            <!-- <el-form-item>
                       <el-link type="warning" class="ellink" :underline="false">提示：预警阈值(商品销售数量的百分比例)</el-link>
                     </el-form-item> -->
                                        </el-row>
                                        <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                                            <el-form-item v-if="formOneValue.isShow == 1" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []" :prop="formOneValue.entityField"
                                                          v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <el-switch class="form_codition" v-if="formOneValue.entityField == 'isDetail'" title="switch" :disabled="true" v-model="isShowDetail">
                                                </el-switch>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'formatter'">{{
													getValue(sendDataInfo[formOneValue.entityField],
														formOneValue.entityField, formOneValue.fieldType,
														formOneValue.formatterContent) }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini" v-if="isShowDetail">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                                        </div>
                                        <el-table size="mini" class="baseTable" ref="mxTableRef" :data="sendDataInfo.detailList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                                  @selection-change="handleSelectionChange" :height="mxHeight" border style="width: 100%">
                                            <el-table-column align="center" label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight"
                                                             v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow==1">
                                                <template slot-scope="scope">
                                                    <!-- 显示通用名称 -->
                                                    <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2" clearable
                                                              @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '',formOneValue.focusField,formOneValue.nosetField)"
                                                              v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]">
                                                        <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '',formOneValue.focusField,formOneValue.nosetField)" slot="append"
                                                                   icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <!-- 数量 num-->
                                                    <el-input v-else-if="formOneValue.entityField == 'num' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                              type="number" min="0" @input="calculatePrice(3,scope.$index)">
                                                    </el-input>
                                                    <!-- 含税价格 psprice-->
                                                    <el-input v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                              type="number" min="0" @input="calculatePrice(1,scope.$index)">
                                                    </el-input>
                                                    <!-- 含税金额 psmoney-->
                                                    <el-input v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                              type="number" min="0" @input="calculatePrice(2,scope.$index)">
                                                    </el-input>
                                                    <!-- 折前价格 disPreprice-->
                                                    <el-input v-else-if="formOneValue.entityField == 'disPreprice' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                              type="number" min="0" @input="calculatePrice(6,scope.$index)">
                                                    </el-input>
                                                    <!-- 反扣比例 buckleProportion-->
                                                    <el-input v-else-if="formOneValue.entityField == 'buckleProportion' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                              type="number" min="0" @input="backstepping(1,scope.$index)">
                                                        <el-button slot="append">%</el-button>
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'buckleMoney' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" v-model="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                              type="number" min="0" @input="backstepping(2,scope.$index)">
                                                    </el-input>
                                                    <el-input v-else-if="formOneValue.entityField == 'remark' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                              @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" clearable :disabled="formOneValue.isChange == 0" type="text"
                                                              v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"></el-input>
                                                    <span v-else>{{sendDataInfo.detailList[scope.$index][formOneValue.entityField]}}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>

                                </div>
                                <!-- 销售合同附件 -->
                                <div v-if="scope.index == 1 && scope.row.isShowForm != 1">
                                    <el-form :inline="true" size="mini" ref="conFile">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="openUpFile">新增附件</el-button>
                                            <el-button type="primary" size="mini" @click="delFile">删除附件</el-button>
                                            <el-button v-if="printScanShow" type="primary" size="mini" @click="openScanner">扫描附件</el-button>
                                        </div>
                                        <el-table size="mini" :data="sendDataInfo.uploadVoList" border style="width: 100%" :height="mxHeight">
                                            <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex1" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" :min-width="formOneValue.fieldWeight"
                                                             v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <!-- 备注 -->
                                                    <el-input v-if="formOneValue.entityField == 'conaRemark'" clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" type="text"
                                                              v-model.trim="sendDataInfo.uploadVoList[scope.$index][formOneValue.entityField]"></el-input>
                                                    <div class="demo-image__preview" v-else-if="formOneValue.entityField == 'fileUrl'">
                                                        <!-- <el-image 
                               style="width: 20px; height: 20px"
                               :src="imgUrl+'/'+scope.row.fileUrl" 
                               :preview-src-list="[imgUrl+'/'+scope.row.fileUrl]">
                             </el-image> -->
                                                        <cusImage style="width: 20px; height: 20px" :src="imgUrl + '/' + scope.row.fileUrl" :preview-src-list="[imgUrl + '/' + scope.row.fileUrl]">
                                                        </cusImage>

                                                    </div>
                                                    <span v-else>{{sendDataInfo.uploadVoList[scope.$index][formOneValue.entityField]}}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog title="扫描仪上传" :visible.sync="scanShow" width="80%" append-to-body top="20px">
            <scannerPlugin v-if="scanShow" ref="scannerPluginDialog" @submit="scanOnSubmit"></scannerPlugin>
        </el-dialog>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog title="上传合同" :visible.sync="dialogUp" width="600px" :modal-append-to-body='true' :append-to-body="true">
            <div>
                <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" ref="upload" :action="requesUrl + '/upload/fileupload'" :headers="token" :on-preview="handlePreview"
                           :on-remove="handleRemove" :file-list="fileList" :limit="20" :on-success="handleAvatarSuccess" :auto-upload="false" :on-exceed="handleExceed" multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogUp = false">取 消</el-button>
                <el-button type="primary" @click="submitUpload">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
 
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
    name: "suContractListAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem("token") },
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            selectedDetails: [],
            selectGoodsInfo: "",
            selectedDetailsIndex: 0,
            DialogExtract: false,
            ppId: "pmId",
            exTitle: "",
            exWidth: "90%",
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            goodsList: [],
            loading: false,
            mxHeight: 0,
            defaultDetail: {
                bgmId: "",
                bgmName: "",
                condRemark: "",
                condWarn: "",
                num: 0,
                psmoney: 0,
                psprice: 0,
                buckleMoney: 0,
            },
            seTitle: "",
            DialogVisible: false,
            isShowDetail: false,
            seIndex: 0,
            seId: "",
            seType: "",
            seWidth: "",
            parentSearchData: {},
            dialogUp: false,
            isChange: false,
            requesUrl: "",
            imgUrl: "",
            fileList: [],
            fileHeight: 0,
            selectedDetailsIndex1: 0,
            tabForm: [],
            mxForm: [],
            footForm: [],
            fField: "",
            sField: "",
            selectedRow: [], // 当前已选择行
            // 扫描仪上传
            scanShow: false,
            printScanShow: false,//判断是否使用打印机扫描 true：是 false：不是
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.detailList": {
            handler: function (newValue, oldValue) {
                if (this.isShowDetail && newValue.length > 0) {
                    this.sendDataInfo.totalMoney = 0;
                    this.sendDataInfo.totalCount = 0;
                    this.sendDataInfo.totalNumber = 0;
                    newValue.forEach((item, keys) => {
                        this.$set(item, 'disPreprice', this.$common.updataNum('disPreprice', item).disPreprice)
                        this.$set(item, 'num', this.$common.updataNum('num', item).num)
                        this.$set(item, 'psprice', this.$common.updataNum('psprice', item).psprice)
                        this.$set(item, 'psmoney', this.$common.updataNum('psmoney', item).psmoney)
                        this.$set(item, 'buckleMoney', this.$common.updataNum('buckleMoney', item).buckleMoney)
                        this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                            3,
                            NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
                        );
                        this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
                            1,
                            NP.plus(this.sendDataInfo.totalNumber, item.num)
                        );
                    });
                    this.sendDataInfo.totalCount = newValue.length;
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        openScanner(){
            this.scanShow = true;
        },
        // 扫描仪上传
        scanOnSubmit(val) {
            // 确保 uploadVoList 存在
            if (!this.sendDataInfo.uploadVoList) {
                this.sendDataInfo.uploadVoList = []
            }
            // 添加新文件
            this.sendDataInfo.uploadVoList = [...this.sendDataInfo.uploadVoList, ...val]
            this.scanShow = false
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue === val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value === val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key === val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        //是否有明细
        changeOrder(e) {
            for (let key in this.sendDataInfo) {
                if (key == "detailList" || key == "uploadVoList") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.conmCreater = this.$store.getters.getUserInfo.opmId;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.uploadVoList = [];
            this.sendDataInfo.detailList = [];
        },
        async getPartDictionariesData() {//字典项
            let responseData = await this.$http.getPartDictionariesData({ ids: [57] })
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result
                console.log(this.dictionariesData)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        // 文件上传服务器
        submitUpload() {
            this.$refs.upload.submit();
        },
        // 文件上传成功回调
        handleAvatarSuccess(res, file, fileList) {
            this.dialogUp = false;
            this.$message({
                message: "上传成功",
                type: "success",
            });
            var midArr = res.result;
            midArr.forEach((v) =>
                this.sendDataInfo.uploadVoList.push(JSON.parse(JSON.stringify(v)))
            );
        },
        handleClose(done) {
            this.$confirm("确认取消文件上传？")
                .then((_) => {
                    done();
                })
                .catch((_) => { });
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 20 个文件，本次选择了 ${files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        openUpFile() {
            this.fileList = [];
            this.dialogUp = true;
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                if (this.seType == "bgmName") {
                    for (let key in val) {
                        this.sendDataInfo.detailList[this.seIndex][key] = val[key];
                    }
                    this.$nextTick(() => {
                        this.tableNextFocus(this.fField, this.seIndex);
                        this.selectedDetailsIndex = this.seIndex;
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex]
                        );
                    });
                }
                else if (this.seType == "cmName") {
                    this.sendDataInfo.cmId = val.cmId;
                    this.sendDataInfo.cmName = val.cmName;
                    this.$http.queryDefaultSales({
                        ids: [val.cmId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            var valObj = {
                                ...val,
                                ...res.result,
                            }
                            this.paramValue(valObj);
                        } else {
                            this.paramValue(val);
                        }
                    })
                } else {
                    this.paramValue(val);
                }
            }
            this.DialogVisible = false;
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.detailList.length > 0) {
                }
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.inputel[aindex].focus();
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == "keydown") {
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                this.addDetail("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },
        closeChild() {
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex);
            });
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, fField) {
            if (type == "salesName") {
                if (
                    this.sendDataInfo.cmId == undefined ||
                    this.sendDataInfo.cmId == ""
                ) {
                    return this.$message({
                        message: "请先选择供应商",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.unitId = this.sendDataInfo.cmId;
                }
            }
            if (type == 'opmName') {
                this.parentSearchData.opmSalesperson = 1

            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            if (type == "bgmName") {
                this.parentSearchData[type] =
                    this.sendDataInfo.detailList[this.seIndex][type];
                return;
            }
            this.parentSearchData[type] = this.sendDataInfo[type];
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 触发提取方案
        openExComponents(e) {
            this.exId = e;
            this.DialogExtract = true;
            removeEventListener("keyup", this.keyUp);
        },
        // 获取 提取单数据
        async getExData(val) {
            for (let key in val) {
                if (key == "arrlistbychen") {
                    this.sendDataInfo.detailList = val.arrlistbychen;
                    this.sendDataInfo.detailList.forEach((info, index) => {
                        // 计算整件数量
                        this.sendDataInfo.detailList[index].wholeNum = Math.floor(
                            NP.divide(
                                parseFloat(info.num),
                                parseFloat(info.packingSpec)
                            )
                        );
                        //计算零散数量
                        this.sendDataInfo.detailList[index].scatNum =
                            parseFloat(info.num) -
                            parseFloat(info.wholeNum) * parseFloat(info.packingSpec);
                        //计算税额
                        this.sendDataInfo.detailList[index].taxAmount =
                            this.$common.getDecimalInfo(
                                3,
                                NP.minus(
                                    parseFloat(info.psmoney),
                                    parseFloat(info.money)
                                )
                            );
                        // 计算件数 采数/包装单位
                        if (
                            parseFloat(info.packingSpec) <= 0 ||
                            info.packingSpec == ""
                        ) {
                            this.sendDataInfo.detailList[index].pieceNum = 0;
                        } else {
                            this.sendDataInfo.detailList[index].pieceNum =
                                this.$common.getDecimalInfo(
                                    1,
                                    NP.divide(
                                        parseFloat(info.num),
                                        parseFloat(info.packingSpec)
                                    )
                                );
                        }
                    });
                } else {
                    this.sendDataInfo[key] = val[key];
                }
            }
            // this.sendDataInfo.detailList.forEach((item) => {
            //     item.psrgdRecnumber = item.collectionCount;
            //     item.psrgdPsupperlimit = 0;
            //     item.wholeNum = 0;
            //     item.scatNum = 0;
            //     item.taxAmount = 0;
            //     item.psrgdWaitnum = item.collectionCount;
            // });
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
            // this.sendDataInfo.psrgmRedate = this.$moment().valueOf();
            this.DialogExtract = false;
            this.$nextTick(() => {
                this.selectedDetailsIndex = 0;
                this.tableNextFocus("psrgdRecnumber", 0);
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.detailList[this.selectedDetailsIndex]
                );
            });
            console.log(this.sendDataInfo);
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        showPrintPlan() {
            // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                console.log(this.actionData);
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.detailList.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.detailList.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.detailList.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.detailList.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        toDetail(orderId) {
            this.$parent.$parent.$parent.toDetail(orderId);
        },
        // 计算价格
        calculatePrice(cate = 1, index) {
            var info = this.sendDataInfo["detailList"][index];
            if (info.num <= 0) {
                this.$message({
                    message: "请先填写数量",
                    type: "error",
                });
                return false;
            }

            switch (cate) {
                case 1: // 通过含税价格计算
                    // 计算单价 含税价格/(税率/100+1)
                    var thisPrice = NP.divide(
                        info.psprice,
                        NP.plus(NP.divide(info.inRate, 100), 1)
                    );
                    this.sendDataInfo.detailList[index].price =
                        this.$common.getDecimalInfo(2, thisPrice);
                    // 计算金额 单价*数量
                    this.sendDataInfo.detailList[index].money =
                        this.$common.getDecimalInfo(3, NP.times(thisPrice, info.num));
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo["detailList"][index].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.psprice, info.num)
                        );
                    //计算税额
                    this.sendDataInfo.detailList[index].taxAmount =
                        this.$common.getDecimalInfo(
                            3,
                            NP.minus(
                                this.sendDataInfo.detailList[index].psmoney,
                                this.sendDataInfo.detailList[index].money
                            )
                        );
                    break;
                case 2: // 通过含税金额计算
                    // 计算含税价格  含税金额 / 数量
                    var thisPrice = NP.divide(info.psmoney, info.num);
                    this.sendDataInfo["detailList"][index].psprice =
                        this.$common.getDecimalInfo(2, thisPrice);
                    // 计算整件数量
                    this.sendDataInfo.detailList[index].wholeNum = Math.floor(
                        NP.divide(info.num, Number(info.packingSpec))
                    );
                    //计算零散数量
                    this.sendDataInfo.detailList[index].scatNum =
                        info.num - info.wholeNum * Number(info.packingSpec);
                    //计算税额
                    this.sendDataInfo.detailList[index].taxAmount =
                        this.$common.getDecimalInfo(
                            3,
                            NP.minus(
                                this.sendDataInfo.detailList[index].psmoney,
                                info.money
                            )
                        );
                    // 计算单价 含税价格/(税率/100+1)
                    var cthisPrice = NP.divide(
                        this.sendDataInfo["detailList"][index].psprice,
                        NP.plus(NP.divide(info.inRate, 100), 1)
                    );
                    this.sendDataInfo.detailList[index].price =
                        this.$common.getDecimalInfo(2, cthisPrice);
                    // 计算金额 单价*数量
                    this.sendDataInfo.detailList[index].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(cthisPrice, info.num)
                        );
                    break;
                default:
                    // 通过数量计算
                    // 计算含税金额 含税价格*数量
                    this.sendDataInfo["detailList"][index].psmoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.psprice, info.num)
                        );
                    // 计算整件数量
                    this.sendDataInfo.detailList[index].wholeNum = Math.floor(
                        NP.divide(info.num, Number(info.packingSpec))
                    );
                    //计算零散数量
                    this.sendDataInfo.detailList[index].scatNum =
                        info.num - info.wholeNum * Number(info.packingSpec);
                    //计算税额
                    this.sendDataInfo.detailList[index].taxAmount =
                        this.$common.getDecimalInfo(
                            3,
                            NP.minus(info.psmoney, info.money)
                        );
                    // 计算金额 单价*数量
                    this.sendDataInfo.detailList[index].money =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(info.price, info.num)
                        );
                    // 计算件数 采数/包装单位
                    if (
                        parseFloat(info.packingSpec) <= 0 ||
                        info.packingSpec == ""
                    ) {
                        this.sendDataInfo.detailList[index].pieceNum = 0;
                    } else {
                        this.sendDataInfo.detailList[index].pieceNum =
                            this.$common.getDecimalInfo(
                                1,
                                NP.divide(info.num, info.packingSpec)
                            );
                    }
                    break;
            }
            this.sendDataInfo.detailList[index].disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0))

        },
        backstepping(cate, index) {
            var info = this.sendDataInfo["detailList"][index];
            switch (cate) {
                case 1: // 反扣比例
                    // 反扣金额 反扣比例*含税金额
                    this.sendDataInfo["detailList"][index].buckleMoney =
                        this.$common.getDecimalInfo(
                            3,
                            NP.times(
                                parseFloat(info.buckleProportion / 100),
                                parseFloat(info.psmoney)
                            )
                        );
                    break;
                case 2: // 反扣金额
                    // 反扣比例  反扣金额 / 含税金额
                    // this.sendDataInfo["detailList"][index].buckleProportion = (

                    //   this.$common.getDecimalInfo(
                    //     2,
                    //     NP.divide(
                    //       parseFloat(info.buckleMoney),
                    //       parseFloat(info.psmoney)
                    //     )
                    //   ) * 100
                    // ).toFixed(2);
                    this.sendDataInfo["detailList"][index].buckleProportion = this.$common.getDecimalInfo(
                        2, (
                        this.$common.getDecimalInfo(
                            2,
                            NP.divide(
                                parseFloat(info.buckleMoney),
                                parseFloat(info.psmoney)
                            )
                        ) * 100
                    ))
                    break;
                default:
                    break;
            }
        },
        async fileUpload(event) {
            var file = event.target.files[0];
            var requestData = {
                file: file,
            };

            const loading = this.$loading({
                lock: true,
                text: "文件上传中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let saveData = await this.$http.uploadFile(requestData, true);
            if (saveData.status == 200) {
                this.$message({
                    type: "success",
                    message: "文件上传成功",
                });
                loading.close();
                this.sendDataInfo.uploadVoList.push(saveData.result);

                this.$refs.clearFile.value = null;
            } else {
                loading.close();
                this.$message({
                    type: "error",
                    message: saveData.message,
                });
            }
        },
        initActionBox(sendDataInfo) {
            this.$confirm(
                "确定取消" + this.dataActionBox.boxTitle + "吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    this.$emit("drawerCancel", 0);
                    // this.$parent.getDataList()
                    this.init();
                    // this.$refs[sendDataInfo][0].resetFields();
                })
                .catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }

            this.sendDataInfo.conmCreater = this.$store.getters.getUserInfo.opmId;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.uploadVoList = [];
            this.sendDataInfo.detailList = [];

            // this.dataActionBox.actionType = 0;
            // this.dataActionBox.showStatus = false;
        },
        isShowData(name, value) {
            var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
            if (dataInfo) {
                dataInfo = JSON.parse(dataInfo);
                this.sendDataInfo.detailList.push({
                    bgmId: dataInfo.bgmId,
                    bgmName: dataInfo.bgmName,
                    bgmPlaceorigin: dataInfo.bgmPlaceorigin,
                    bgmSpecifications: dataInfo.bgmSpecifications,
                    bgmManufacturer: dataInfo.bgmManufacturer,
                    num: 0,
                    condRemark: "",
                    psmoney: 0,
                    psprice: 0,
                    condReserves1: "",
                    condReserves2: "",
                    condReserves3: "",
                    condReserves4: "",
                    condReserves5: "",
                    condReserves6: "",
                });
            }
        },
        // 新增明细
        addDetail(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    var info = JSON.parse(JSON.stringify(this.defaultDetail));
                    this.sendDataInfo.detailList.push(info);
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.detailList.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.detailList[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善信息",
                        type: "error",
                    });
                }
            });
        },
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            this.isShowDetail = false
            this.filterMainField();
            this.getPartDictionariesData()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                if (oldData.detailList && oldData.detailList.length > 0) {
                    this.isShowDetail = true
                } else {
                    this.isChange = true
                }
                console.log(oldData);
            } else if (this.dataActionBox.actionType == 2) {
                this.dataActionBox.boxTitle = "查看信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                if (oldData.detailList && oldData.detailList.length > 0) {
                    this.isShowDetail = true
                } else {
                    this.isChange = true
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus();
                }, 100)
            });
        },
        async sendDataAction() {
            this.$refs["sendDataInfo"].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    return this.$message({
                        message: "请完善信息",
                        type: "error",
                    });
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.dataActionBox.actionType == 0) {
                if (sendData.detailList.length > 0) {
                    sendData.detailList.forEach((item, index) => {
                        item.rowno = index
                    })
                }
                var responseData = await this.$http.addsucontract(sendData);
            } else {
                var responseData = await this.$http.editsucontract(sendData);
            }
            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", 1);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        deleteDetails() {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    this.sendDataInfo.detailList.splice(
                        this.selectedDetailsIndex,
                        1
                    );
                    this.$nextTick(() => {
                        if (this.sendDataInfo.detailList.length > 1) {
                            this.selectedDetailsIndex = Number(
                                this.selectedDetailsIndex - 1
                            );
                            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                            let refsElTable = this.$refs.mxTableRef;
                            refsElTable.clearSelection();
                            refsElTable.toggleRowSelection(
                                this.sendDataInfo.detailList[
                                this.selectedDetailsIndex
                                ]
                            );
                        } else {
                            this.selectedDetailsIndex = 0;
                        }
                    });
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                })
                .catch(() => { });
        },
        delFile() {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    this.sendDataInfo.uploadVoList.splice(
                        this.selectedDetailsIndex1,
                        1
                    );
                    this.$message({
                        message: "删除成功",
                        type: "success",
                    });
                })
                .catch(() => { });
        },
        // 获取业务员
        async getSpecialUser() {
            let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 });
            if (responseData.status == 200) {
                this.userOneList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        //获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));

                    this.mxForm.forEach(item1 => {
                        if (item1.fieldType == 'number') {
                            this.$set(this.defaultDetail, item1.entityField, 0)
                        } else if (item1.fieldType == 'search' && item1.setField) {
                            var arr = item1.setField.split(',')
                            arr.forEach(item2 => {
                                this.$set(this.defaultDetail, item2, "")
                            })
                        } else {
                            this.$set(this.defaultDetail, item1.entityField, "")
                        }
                    })


                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "uploadVoList" }, { entityField: "detailList" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, 'conmCreater', this.$store.getters.getUserInfo.opmId)
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgurl();
        this.$nextTick(() => {
            this.printScanShow = window.global_config.printScanShow?true:false;
            this.openBox();
        });
        this.getSpecialUser();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.ellink {
    width: 263px;
    margin-left: -76px;
    margin-top: 10px;
}

/* .table_content_box {
   height: 500px !important;
   overflow-y: auto;
 } */
</style>